export const forcePositiveNumberInput = (event) => {
    if (event.key === '-' || event.key === 'e') event.preventDefault();
};
